import { createAction } from '@reduxjs/toolkit';
import type { AnyUserEvent } from '~/store/userEvents/userEvents.type';

export const trackUserEvent = createAction('TRACK_USER_EVENT', (userEvent: AnyUserEvent) => ({
  payload: userEvent,
}));
